var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaticDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 257.863,
    height: 212.075,
    viewBox: "0 0 257.863 212.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_real_time_sync_re_nky7",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164783",
    "data-name": "Path 164783",
    d: "M796.817,176.107c1.648-6.72.081-14.557-5.242-18.977a31.878,31.878,0,0,1-7.8,20.451c-1.91,2.185-4.261,4.416-4.354,7.317a7.126,7.126,0,0,0,2.037,4.875,21.162,21.162,0,0,0,4.259,3.322l.222.392C790.814,188.572,795.169,182.827,796.817,176.107Z",
    transform: "translate(-586.96 -154.79)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164784",
    "data-name": "Path 164784",
    d: "M799.63,156.993a27.248,27.248,0,0,1,.868,16.742,11.734,11.734,0,0,1-1.433,3.386,6.73,6.73,0,0,1-2.676,2.321,13.928,13.928,0,0,0-2.942,1.648,4.12,4.12,0,0,0-1.386,3.072,10.7,10.7,0,0,0,.956,4.152,10.512,10.512,0,0,1,1.061,4.614c-.016.2.289.209.3.014.231-2.811-1.678-5.185-1.981-7.911a4.173,4.173,0,0,1,1.041-3.522,10.807,10.807,0,0,1,2.955-1.729,7.181,7.181,0,0,0,2.7-2.172,10.847,10.847,0,0,0,1.558-3.318,26.436,26.436,0,0,0,1.057-8.194,27.734,27.734,0,0,0-1.813-9.243c-.07-.183-.339-.04-.27.142Z",
    transform: "translate(-595.122 -154.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164785",
    "data-name": "Path 164785",
    d: "M817.28,194.1a4.088,4.088,0,0,0,4.433-2.893c.055-.188-.235-.283-.29-.094a3.785,3.785,0,0,1-4.129,2.683C817.1,193.769,817.086,194.074,817.28,194.1Z",
    transform: "translate(-611.323 -176.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164786",
    "data-name": "Path 164786",
    d: "M802.168,209.967a7.879,7.879,0,0,1-1.672-5.494c.015-.2-.289-.209-.3-.014a8.2,8.2,0,0,0,1.751,5.713C802.065,210.326,802.29,210.12,802.168,209.967Z",
    transform: "translate(-600.36 -185.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164787",
    "data-name": "Path 164787",
    d: "M813.945,172.943a2.314,2.314,0,0,1-2.01-.885c-.12-.155-.345.051-.225.206a2.593,2.593,0,0,0,2.221.984.158.158,0,0,0,.159-.145.153.153,0,0,0-.146-.159Z",
    transform: "translate(-607.793 -164.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164788",
    "data-name": "Path 164788",
    d: "M748.735,169.416c.072.1.145.2.216.3a30.468,30.468,0,0,1,2.557,4.23c.059.113.117.229.172.344A32.126,32.126,0,0,1,754.8,185.7a31.2,31.2,0,0,1,.022,4.74c-.156,2.18-.5,4.531.058,6.575a5.363,5.363,0,0,0,.206.63l10.541,4.018.085-.006.414.18c.012-.081.022-.165.033-.246.007-.047.011-.095.018-.142,0-.032.008-.063.013-.092,0-.01,0-.021,0-.029.005-.028.007-.055.012-.081q.087-.706.165-1.416s0,0,0-.006a45.874,45.874,0,0,0,0-10.846c-.014-.107-.027-.217-.046-.326a29.784,29.784,0,0,0-1.054-4.743,26.32,26.32,0,0,0-.924-2.5,21.886,21.886,0,0,0-3.656-5.784,17.379,17.379,0,0,0-11.61-6.191C748.964,169.429,748.851,169.422,748.735,169.416Z",
    transform: "translate(-567.139 -162.726)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164789",
    "data-name": "Path 164789",
    d: "M748.519,169.274a27.247,27.247,0,0,1,10.773,12.845,11.732,11.732,0,0,1,.894,3.566,6.73,6.73,0,0,1-.739,3.464,13.926,13.926,0,0,0-1.357,3.086,4.121,4.121,0,0,0,.742,3.287,10.706,10.706,0,0,0,3.263,2.739,10.513,10.513,0,0,1,3.625,3.046c.1.166.356-.007.252-.172-1.508-2.383-4.461-3.129-6.345-5.124a4.173,4.173,0,0,1-1.29-3.439,10.809,10.809,0,0,1,1.318-3.16,7.181,7.181,0,0,0,.849-3.36,10.846,10.846,0,0,0-.753-3.587,26.435,26.435,0,0,0-4.089-7.179A27.732,27.732,0,0,0,748.649,169c-.166-.1-.295.173-.13.276Z",
    transform: "translate(-566.95 -162.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164790",
    "data-name": "Path 164790",
    d: "M776.967,191.894a4.088,4.088,0,0,0,1.8-4.979c-.069-.184-.358-.084-.288.1a3.785,3.785,0,0,1-1.682,4.628C776.623,191.739,776.8,191.99,776.967,191.894Z",
    transform: "translate(-585.217 -173.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164791",
    "data-name": "Path 164791",
    d: "M771.442,218.315a7.879,7.879,0,0,1-4.642-3.38c-.106-.166-.357.007-.252.172a8.2,8.2,0,0,0,4.838,3.507C771.577,218.664,771.631,218.364,771.442,218.315Z",
    transform: "translate(-578.628 -192.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164792",
    "data-name": "Path 164792",
    d: "M758.536,180.751a2.314,2.314,0,0,1-2.137.5c-.19-.052-.244.248-.056.3a2.593,2.593,0,0,0,2.366-.551.157.157,0,0,0,.039-.212.153.153,0,0,0-.212-.04Z",
    transform: "translate(-571.977 -170.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164793",
    "data-name": "Path 164793",
    d: "M592.463,364.294a64.089,64.089,0,1,1,11.153-127.211.354.354,0,1,1-.13.7A63.387,63.387,0,1,0,655.845,300.2a63.221,63.221,0,0,0-16.534-42.692.354.354,0,1,1,.523-.477,64.09,64.09,0,0,1-47.371,107.258Z",
    transform: "translate(-424.804 -205.808)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1242",
    "data-name": "Ellipse 1242",
    cx: 12.68,
    cy: 12.68,
    r: 12.68,
    transform: "translate(183.238 26.927)",
    fill: "#4f7ba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164794",
    "data-name": "Path 164794",
    d: "M775.413,256.941a1.41,1.41,0,0,1-1.128-.564l-3.459-4.613a1.41,1.41,0,0,1,2.257-1.692l2.263,3.017,5.813-8.719a1.411,1.411,0,0,1,2.347,1.565l-6.919,10.378a1.411,1.411,0,0,1-1.134.628Z",
    transform: "translate(-581.225 -210.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164795",
    "data-name": "Path 164795",
    d: "M569.176,234.979l-19.554-54.4.5-.178-3.6-10.005-.5.178-6-16.7a5.048,5.048,0,0,0-6.458-3.043l-35.349,12.706A5.048,5.048,0,0,0,495.173,170l4.186,11.646-.783.3,2.672,6.939.627-.242.555,1.543-.667.257,2.672,6.939.511-.2L524.327,251.1a5.039,5.039,0,0,0,6.458,3.043l35.349-12.706a5.054,5.054,0,0,0,3.043-6.458Z",
    transform: "translate(-403.166 -150.529)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164796",
    "data-name": "Path 164796",
    d: "M532.887,255.844a2.424,2.424,0,0,1-2.275-1.6L501.151,172.28a2.419,2.419,0,0,1,1.458-3.094l7.521-2.7-.011.263a2.788,2.788,0,0,0,3.728,2.741l16.692-6a2.824,2.824,0,0,0,1.589-2,2.765,2.765,0,0,0-.659-2.42l-.176-.2,7.769-2.793a2.422,2.422,0,0,1,3.094,1.458l28.109,78.2a6.425,6.425,0,0,1-3.869,8.211l-32.69,11.75A2.422,2.422,0,0,1,532.887,255.844Z",
    transform: "translate(-407.128 -154.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1243",
    "data-name": "Ellipse 1243",
    cx: 9.56,
    cy: 9.56,
    r: 9.56,
    transform: "translate(113.319 24.568)",
    fill: "#e62d2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164797",
    "data-name": "Path 164797",
    d: "M587.377,283.209l-33.108,11.9a.836.836,0,0,1-.566-1.574l33.108-11.9a.836.836,0,0,1,.566,1.574Z",
    transform: "translate(-440.807 -235.178)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164798",
    "data-name": "Path 164798",
    d: "M600.139,304.519l-10.89,3.914a.836.836,0,0,1-.566-1.574l10.89-3.914a.836.836,0,0,1,.566,1.574Z",
    transform: "translate(-463.401 -248.942)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164799",
    "data-name": "Path 164799",
    d: "M607.454,324.87l-10.89,3.914A.836.836,0,1,1,596,327.21l10.89-3.915a.836.836,0,1,1,.566,1.574Z",
    transform: "translate(-468.126 -262.087)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164800",
    "data-name": "Path 164800",
    d: "M611.2,335.293l-10.89,3.915a.836.836,0,1,1-.566-1.574l10.89-3.914a.836.836,0,0,1,.566,1.574Z",
    transform: "translate(-470.546 -268.82)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164801",
    "data-name": "Path 164801",
    d: "M598.711,308.352l-23.1,8.305a.836.836,0,1,1-.566-1.574l23.105-8.305a.836.836,0,1,1,.566,1.574Z",
    transform: "translate(-454.589 -251.418)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164802",
    "data-name": "Path 164802",
    d: "M619.072,358.522l-3.954,1.421a1.422,1.422,0,0,1-.962-2.676l3.954-1.421a1.422,1.422,0,0,1,.962,2.676Z",
    transform: "translate(-479.604 -283.089)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1244",
    "data-name": "Ellipse 1244",
    cx: 0.55,
    cy: 0.55,
    r: 0.55,
    transform: "translate(107.758 11.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164803",
    "data-name": "Path 164803",
    d: "M343.809,253.853c6.163-7.255,16.163-11.827,25.382-9.456a43.858,43.858,0,0,0-16.513,25.18c-.9,3.89-1.488,8.311-4.646,10.752a9.8,9.8,0,0,1-7.077,1.659,29.118,29.118,0,0,1-7.137-2.07l-.616.068C334.753,270.6,337.646,261.108,343.809,253.853Z",
    transform: "translate(-298.74 -210.75)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164804",
    "data-name": "Path 164804",
    d: "M369.254,245.335a37.487,37.487,0,0,0-19.363,12.531,16.14,16.14,0,0,0-2.619,4.327,9.259,9.259,0,0,0-.43,4.854,19.163,19.163,0,0,1,.535,4.608,5.669,5.669,0,0,1-2.307,4.022,14.73,14.73,0,0,1-5.4,2.281c-2.108.55-4.306,1.087-6,2.538-.205.176-.466-.153-.261-.328,2.947-2.523,7.133-2.309,10.416-4.17a5.741,5.741,0,0,0,3.087-4,14.868,14.868,0,0,0-.454-4.688,9.879,9.879,0,0,1,.243-4.762,14.926,14.926,0,0,1,2.443-4.412,36.37,36.37,0,0,1,8.283-7.785,38.151,38.151,0,0,1,11.766-5.431c.26-.07.318.346.06.415Z",
    transform: "translate(-298.827 -211.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164805",
    "data-name": "Path 164805",
    d: "M381.521,262.255a5.624,5.624,0,0,1-.349-7.274c.165-.213.5.034.339.247a5.208,5.208,0,0,0,.338,6.766c.185.2-.144.456-.328.261Z",
    transform: "translate(-328.97 -217.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164806",
    "data-name": "Path 164806",
    d: "M370.431,300.519a10.84,10.84,0,0,0,7.472-2.566c.206-.175.467.154.261.328a11.276,11.276,0,0,1-7.781,2.654C370.113,300.923,370.162,300.507,370.431,300.519Z",
    transform: "translate(-322.639 -245.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164807",
    "data-name": "Path 164807",
    d: "M411.125,254.7a3.183,3.183,0,0,0,2.607,1.527c.27.009.221.426-.048.417a3.567,3.567,0,0,1-2.888-1.682.217.217,0,0,1,.034-.295A.211.211,0,0,1,411.125,254.7Z",
    transform: "translate(-348.831 -217.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164808",
    "data-name": "Path 164808",
    d: "M382.053,312.5c-.169,0-.338,0-.509,0a41.922,41.922,0,0,0-6.778.56c-.174.026-.349.055-.522.085a44.2,44.2,0,0,0-15.233,5.723,42.918,42.918,0,0,0-5.3,3.8c-2.3,1.931-4.649,4.209-7.376,5.236a7.37,7.37,0,0,1-.868.278l-12.977-8.512c-.02-.034-.042-.065-.062-.1l-.534-.316c.081-.078.167-.157.248-.236.047-.046.1-.089.143-.135.032-.03.064-.059.092-.088l.03-.027c.027-.029.056-.052.081-.078q.717-.667,1.445-1.326s0,0,.007,0a63.109,63.109,0,0,1,12.089-8.747c.131-.071.264-.144.4-.211a40.961,40.961,0,0,1,6.137-2.649,36.21,36.21,0,0,1,3.529-.984,30.111,30.111,0,0,1,9.4-.587c6.266.6,12.272,3.188,16.262,7.952C381.854,312.259,381.953,312.379,382.053,312.5Z",
    transform: "translate(-297.894 -249.689)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164809",
    "data-name": "Path 164809",
    d: "M382.349,322.574a37.487,37.487,0,0,0-23-1.653,16.142,16.142,0,0,0-4.7,1.879,9.259,9.259,0,0,0-3.265,3.617,19.164,19.164,0,0,1-2.347,4,5.669,5.669,0,0,1-4.263,1.822,14.729,14.729,0,0,1-5.684-1.43c-2.014-.83-4.092-1.724-6.318-1.586-.27.017-.28-.4-.011-.419,3.872-.24,7.086,2.451,10.827,2.942a5.741,5.741,0,0,0,4.873-1.335,14.868,14.868,0,0,0,2.46-4.017,9.88,9.88,0,0,1,3.061-3.656,14.925,14.925,0,0,1,4.607-2.052,36.369,36.369,0,0,1,11.3-1.229,38.152,38.152,0,0,1,12.664,2.748C382.8,322.308,382.6,322.675,382.349,322.574Z",
    transform: "translate(-298.327 -259.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164810",
    "data-name": "Path 164810",
    d: "M415,310.554a5.624,5.624,0,0,1,4.1-6.018c.261-.071.383.331.122.4a5.208,5.208,0,0,0-3.8,5.606c.03.268-.39.277-.419.011Z",
    transform: "translate(-351.553 -249.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164811",
    "data-name": "Path 164811",
    d: "M385.834,337.008a10.84,10.84,0,0,0,7.511,2.45c.27-.016.28.4.011.419a11.276,11.276,0,0,1-7.81-2.565C385.337,337.139,385.627,336.836,385.834,337.008Z",
    transform: "translate(-332.503 -270.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164812",
    "data-name": "Path 164812",
    d: "M448.776,321.106a3.183,3.183,0,0,0,1.162,2.788c.211.17-.08.473-.289.3a3.568,3.568,0,0,1-1.293-3.082.217.217,0,0,1,.2-.215A.211.211,0,0,1,448.776,321.106Z",
    transform: "translate(-373.11 -260.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164813",
    "data-name": "Path 164813",
    d: "M853.822,634.31c6.72,1.648,14.557.081,18.977-5.242a31.879,31.879,0,0,1-20.451-7.8c-2.185-1.91-4.416-4.261-7.317-4.354a7.126,7.126,0,0,0-4.875,2.037,21.161,21.161,0,0,0-3.322,4.259l-.392.222C841.357,628.307,847.1,632.663,853.822,634.31Z",
    transform: "translate(-623.791 -451.772)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164814",
    "data-name": "Path 164814",
    d: "M873.012,637.124a27.248,27.248,0,0,1-16.742.868,11.734,11.734,0,0,1-3.385-1.433,6.729,6.729,0,0,1-2.321-2.676,13.932,13.932,0,0,0-1.648-2.942,4.121,4.121,0,0,0-3.072-1.386,10.705,10.705,0,0,0-4.152.956,10.512,10.512,0,0,1-4.615,1.061c-.2-.016-.209.289-.014.3,2.811.231,5.185-1.678,7.911-1.981a4.173,4.173,0,0,1,3.522,1.04,10.807,10.807,0,0,1,1.729,2.955,7.182,7.182,0,0,0,2.172,2.7,10.851,10.851,0,0,0,3.318,1.558,26.436,26.436,0,0,0,8.194,1.057,27.731,27.731,0,0,0,9.243-1.813c.183-.07.04-.339-.142-.27Z",
    transform: "translate(-624.102 -459.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164815",
    "data-name": "Path 164815",
    d: "M896.452,654.773a4.088,4.088,0,0,0,2.893,4.433c.188.055.283-.235.094-.29a3.786,3.786,0,0,1-2.683-4.129C896.783,654.592,896.478,654.58,896.452,654.773Z",
    transform: "translate(-662.531 -476.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164816",
    "data-name": "Path 164816",
    d: "M875.506,639.661A7.88,7.88,0,0,1,881,637.99c.2.015.209-.289.014-.3a8.2,8.2,0,0,0-5.713,1.751c-.154.122.053.347.206.225Z",
    transform: "translate(-648.854 -465.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164817",
    "data-name": "Path 164817",
    d: "M921.023,651.438a2.314,2.314,0,0,1,.885-2.009c.155-.12-.051-.345-.206-.225a2.593,2.593,0,0,0-.984,2.221.157.157,0,0,0,.145.159A.153.153,0,0,0,921.023,651.438Z",
    transform: "translate(-678.221 -472.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164818",
    "data-name": "Path 164818",
    d: "M867.693,586.228c-.1.072-.2.145-.3.216a30.474,30.474,0,0,1-4.23,2.557c-.113.059-.229.117-.344.172a32.126,32.126,0,0,1-11.41,3.118,31.186,31.186,0,0,1-4.74.022c-2.18-.156-4.531-.5-6.575.058a5.343,5.343,0,0,0-.63.206l-4.018,10.541c0,.029,0,.056.006.085l-.18.414.246.033.142.018c.032,0,.063.008.091.013l.029,0c.028.005.055.007.081.011q.706.087,1.416.165s0,0,.006,0a45.877,45.877,0,0,0,10.846,0c.107-.014.217-.027.326-.047a29.77,29.77,0,0,0,4.743-1.054,26.308,26.308,0,0,0,2.5-.924,21.885,21.885,0,0,0,5.784-3.656,17.379,17.379,0,0,0,6.191-11.61C867.68,586.458,867.687,586.345,867.693,586.228Z",
    transform: "translate(-623.035 -431.951)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164819",
    "data-name": "Path 164819",
    d: "M867.872,586.012a27.247,27.247,0,0,1-12.845,10.773,11.734,11.734,0,0,1-3.566.894,6.73,6.73,0,0,1-3.464-.739,13.929,13.929,0,0,0-3.087-1.357,4.121,4.121,0,0,0-3.287.742,10.708,10.708,0,0,0-2.739,3.263,10.511,10.511,0,0,1-3.046,3.625c-.166.1.007.356.172.252,2.383-1.508,3.13-4.461,5.124-6.344a4.173,4.173,0,0,1,3.438-1.29,10.807,10.807,0,0,1,3.16,1.318,7.181,7.181,0,0,0,3.36.849,10.85,10.85,0,0,0,3.587-.753,26.433,26.433,0,0,0,7.179-4.089,27.731,27.731,0,0,0,6.288-7.013C868.251,585.976,867.975,585.847,867.872,586.012Z",
    transform: "translate(-623.357 -431.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164820",
    "data-name": "Path 164820",
    d: "M895.055,614.46a4.088,4.088,0,0,0,4.979,1.8c.184-.069.084-.358-.1-.288a3.785,3.785,0,0,1-4.628-1.682C895.21,614.117,894.959,614.29,895.055,614.46Z",
    transform: "translate(-661.635 -450.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164821",
    "data-name": "Path 164821",
    d: "M871.089,608.935a7.879,7.879,0,0,1,3.38-4.642c.166-.106-.007-.357-.172-.252a8.2,8.2,0,0,0-3.507,4.838C870.74,609.07,871.04,609.125,871.089,608.935Z",
    transform: "translate(-645.972 -443.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164822",
    "data-name": "Path 164822",
    d: "M913.827,596.029a2.314,2.314,0,0,1-.5-2.137c.052-.19-.248-.244-.3-.056a2.593,2.593,0,0,0,.551,2.366.158.158,0,0,0,.212.039.153.153,0,0,0,.04-.212Z",
    transform: "translate(-673.2 -436.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164823",
    "data-name": "Path 164823",
    d: "M728.545,398.442,718.3,415.686l.389.205-3.47,6.579-.722-.382-2.28,3.835.567.326-3.718,6.437-.644-.372-33.436,56.271a6.47,6.47,0,0,1-8.859,2.255l-62.16-36.935a6.47,6.47,0,0,1-2.255-8.859L655.27,354.9a6.47,6.47,0,0,1,8.859-2.255l62.16,36.935a6.473,6.473,0,0,1,2.255,8.859Z",
    transform: "translate(-471.587 -280.493)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164824",
    "data-name": "Path 164824",
    d: "M675.97,494.851l-62.379-37.064a2,2,0,0,1-.7-2.731l53.918-90.743a2,2,0,0,1,2.731-.7l62.379,37.064a2,2,0,0,1,.7,2.731L678.7,494.156A2,2,0,0,1,675.97,494.851Z",
    transform: "translate(-479.218 -287.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1245",
    "data-name": "Ellipse 1245",
    cx: 0.55,
    cy: 0.55,
    r: 0.55,
    transform: "translate(221.825 91.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164825",
    "data-name": "Path 164825",
    d: "M758.02,534.67,705.949,503.73a1.44,1.44,0,1,1,1.471-2.475l52.07,30.939a1.44,1.44,0,1,1-1.471,2.475Z",
    transform: "translate(-539.048 -376.935)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164826",
    "data-name": "Path 164826",
    d: "M763.044,559l-17.127-10.177a1.44,1.44,0,1,1,1.471-2.476l17.127,10.177A1.44,1.44,0,1,1,763.044,559Z",
    transform: "translate(-564.863 -406.064)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164827",
    "data-name": "Path 164827",
    d: "M744.025,591.012,726.9,580.835a1.44,1.44,0,0,1,1.471-2.475L745.5,588.536a1.44,1.44,0,1,1-1.471,2.475Z",
    transform: "translate(-552.579 -426.738)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164828",
    "data-name": "Path 164828",
    d: "M734.285,607.406l-17.127-10.177a1.44,1.44,0,0,1,1.471-2.475l17.127,10.177a1.44,1.44,0,0,1-1.471,2.475Z",
    transform: "translate(-546.287 -437.327)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164829",
    "data-name": "Path 164829",
    d: "M745.751,570.08l-36.339-21.592a1.44,1.44,0,1,1,1.471-2.475L747.222,567.6a1.44,1.44,0,0,1-1.471,2.475Z",
    transform: "translate(-541.285 -405.845)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164830",
    "data-name": "Path 164830",
    d: "M780.234,677.237l-6.219-3.7a2.448,2.448,0,0,1,2.5-4.209l6.219,3.7a2.448,2.448,0,0,1-2.5,4.209Z",
    transform: "translate(-582.694 -485.408)",
    fill: "#4f7ba0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1246",
    "data-name": "Ellipse 1246",
    cx: 12.747,
    cy: 12.747,
    r: 12.747,
    transform: "translate(196.396 106.339)",
    fill: "rgba(230,45,46,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164831",
    "data-name": "Path 164831",
    d: "M236.3,445.807H408.8V345.938a2.826,2.826,0,0,0-2.822-2.822H239.12a2.826,2.826,0,0,0-2.822,2.822Z",
    transform: "translate(-236.148 -274.921)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2985",
    "data-name": "Rectangle 2985",
    width: 161.844,
    height: 91.882,
    transform: "translate(5.48 72.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164832",
    "data-name": "Path 164832",
    d: "M235.874,625.5v12.324a3.89,3.89,0,0,0,3.89,3.89h63.67v24.322h-.846a.505.505,0,0,0-.505.505v1.692a.505.505,0,0,0,.505.505h39.525a.505.505,0,0,0,.505-.505v-1.692a.505.505,0,0,0-.505-.505h-.846V641.716h63.67a3.89,3.89,0,0,0,3.89-3.891V625.5Z",
    transform: "translate(-235.874 -457.319)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164833",
    "data-name": "Path 164833",
    d: "M499.153,434.276H422.51a1.822,1.822,0,1,1,0-3.643h76.643a1.822,1.822,0,1,1,0,3.643Z",
    transform: "translate(-355.248 -331.45)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164834",
    "data-name": "Path 164834",
    d: "M520.348,457.5h-25.21a1.822,1.822,0,0,1,0-3.644h25.21a1.822,1.822,0,0,1,0,3.644Z",
    transform: "translate(-402.16 -346.451)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164835",
    "data-name": "Path 164835",
    d: "M520.348,504.613h-25.21a1.822,1.822,0,0,1,0-3.644h25.21a1.822,1.822,0,0,1,0,3.644Z",
    transform: "translate(-402.16 -376.881)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164836",
    "data-name": "Path 164836",
    d: "M520.348,528.743h-25.21a1.822,1.822,0,1,1,0-3.644h25.21a1.822,1.822,0,0,1,0,3.644Z",
    transform: "translate(-402.16 -392.468)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164837",
    "data-name": "Path 164837",
    d: "M508.7,480.727H455.208a1.822,1.822,0,1,1,0-3.643H508.7a1.822,1.822,0,1,1,0,3.643Z",
    transform: "translate(-376.369 -361.453)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164838",
    "data-name": "Path 164838",
    d: "M616.334,573.492h-9.154a3.1,3.1,0,0,1,0-6.2h9.154a3.1,3.1,0,0,1,0,6.2Z",
    transform: "translate(-473.706 -419.723)",
    fill: "#4f7ba0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1247",
    "data-name": "Ellipse 1247",
    cx: 15.934,
    cy: 15.934,
    r: 15.934,
    transform: "translate(27.227 99.417)",
    fill: "#f57779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164839",
    "data-name": "Path 164839",
    d: "M465.493,747.933H236.3a.422.422,0,1,1,0-.843h229.2a.422.422,0,1,1,0,.843Z",
    transform: "translate(-235.874 -535.854)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1248",
    "data-name": "Ellipse 1248",
    cx: 0.601,
    cy: 0.601,
    r: 0.601,
    transform: "translate(85.726 68.945)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticDevices);
export default __webpack_public_path__ + "static/media/static_devices.d71832f1d3c379af6951ba19b414c691.svg";
export { ForwardRef as ReactComponent };